import { Provider } from 'react-redux';

import { withProps } from '#utils';
import store from './store';

export { default as actions } from './actions';
export { default as store } from './store';
export const StoreProvider = withProps({ store }, Provider);
